/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation,  } from '@angular/core';
import {UserService} from "../../../services/user.service";
import { ActivatedRoute} from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import {Router} from "@angular/router";
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var $ : any;
declare var Swal: any

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'mouse-follow-modal',
    templateUrl:'mouse-follow-game.html',
    providers  : [],  
})
export class MouseFollowModal implements OnInit {
  public list;
  public message;
  public images=null
  public points =[{x:10,y:10,t:0},{x:90,y:10,t:10}]
  public timer=0;//miliseconds


  public pointerPosition;
  public moveHandler
  public divSize
  public intendedPosition;
  public startMilis=0;
  public endMilis=0;
    public ngOnInit() : any {
     // document.querySelector('#mouseMotionCanvas').addEventListener('mousemove' , this.handleMouseMove)
      $('#startPoint').css({'left':this.points[0].x+'%'})
      $('#startPoint').css({'top':this.points[0].y+'%'})
      $('#endPoint').css({'left':this.points[1].x+'%'})
      $('#endPoint').css({'top':this.points[1].y+'%'})


    }
   /* public handleMouseMove() {
      var eventDoc, doc, body;
 (pointermove)="handleMouseMove()" 
      event = event || window.event; // IE-ism

      // If pageX/Y aren't available and clientX/Y are,
      // calculate pageX/Y - logic taken from jQuery.
      // (This is to support old IE)
      if (event.pageX == null && event.clientX != null) {
          eventDoc = (event.target && event.target.ownerDocument) || document;
          doc = eventDoc.documentElement;
          body = eventDoc.body;

          event.pageX = event.clientX +
            (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
            (doc && doc.clientLeft || body && body.clientLeft || 0);
          event.pageY = event.clientY +
            (doc && doc.scrollTop  || body && body.scrollTop  || 0) -
            (doc && doc.clientTop  || body && body.clientTop  || 0 );
      }

      $('#pointer').css({'left':event.pageX})
      $('#pointer').css({'top':event.pageY})
      this.pointerPosition={x:event.pageX,y:event.pageY};
  }*/

  public startAction(){
    let date=new Date();
    this.startMilis=date.getTime();
    this.intendedPosition={x:0,y:0}
    var divHeight = $('#mouseMotionCanvas').height();
    var divWidth = $('#mouseMotionCanvas').width();
    this.divSize={x:divWidth,y:divHeight}
    this.intendedPosition.x=(this.points[0].x*this.divSize.x)/100
    this.intendedPosition.y=(this.points[0].y*this.divSize.y)/100
    $('#targetPointer').css({'left':this.intendedPosition.x})
    $('#targetPointer').css({'top':this.intendedPosition.y})
    this.moveHandler=setInterval(()=>{
      let startX=(this.points[0].x*this.divSize.x)/100
      let startY=(this.points[0].y*this.divSize.y)/100
      let endX=(this.points[1].x*this.divSize.x)/100
      let endY=(this.points[1].y*this.divSize.y)/100
      let startTime=this.points[0].t*1000
      let endTime=this.points[1].t*1000
      let speedX=(endX-startX)/(endTime-startTime)//speed in milis
      let speedY=(endY-startY)/(endTime-startTime)//speed in milis
      let date=new Date();
      let milis=date.getTime()-this.startMilis;
      this.intendedPosition.x=startX+speedX*milis;
      this.intendedPosition.y=startY+speedY*milis;
      $('#targetPointer').css({'left':this.intendedPosition.x})
      $('#targetPointer').css({'top':this.intendedPosition.y})
      if (this.intendedPosition.x>endX || this.intendedPosition.y>endY){
        clearTimeout(this.moveHandler);
      }
      let dx=Math.pow((this.intendedPosition.x-this.pointerPosition.x),2)
      let dy=Math.pow((this.intendedPosition.y-this.pointerPosition.y),2)
      let distance=dx+dy;
      let area=this.divSize.x*this.divSize.y;
      let ratio=distance/area
      $('#mouseMotionCanvas').css({'opacity':ratio})
      if (ratio>0.1){
        Swal.fire({title:'acima',text:'acima'+ratio})
      }

    },100)
  }
  public endAction(){
    Swal.fire({title:'end',message:'started'})

  }
   public sendIframeMessage(messageKind){
      let frame='gameFrame'
      if (this._appData.focusIframe){
        frame=this._appData.focusIframe;
      }
      var iframe = document.getElementById(frame);
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }   
    constructor( public _appData : AppDataService,private _companyService : CompanyService,public _sanitizer: DomSanitizer,public _router : Router,private _routeParams : ActivatedRoute,private _auth : UserService) {
    }



}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/gameswithingames/mouse-follow-game.ts